import React from 'react';
import { industries } from './data/content';
import IndustryGrid from './components/IndustryGrid';
import IndustryNav from './components/IndustryNav';
import IndustrySection from './components/IndustrySection';
import GlobalFooter from './components/GlobalFooter';
import FloatingNav from './components/FloatingNav';
import TopBackBar from './components/TopBackBar';

function App() {
  return (
    <div className="min-h-screen bg-white w-full overflow-x-hidden font-sans">
      <TopBackBar />
      <IndustryGrid />
      <IndustryNav />
      <main>
        {industries.map((industry, index) => (
          <IndustrySection key={industry.id} data={industry} index={index} />
        ))}
      </main>
      <GlobalFooter />
      <FloatingNav />
    </div>
  );
}

export default App;